<template>
  <div id="header-mobile" class="dark color-dark relative flex items-center justify-between gap-4 p-4">
    <SiteNavMenuToggler />
    <SiteHeaderTools>
      <SiteNavSearch />
    </SiteHeaderTools>
  </div>
</template>
